/* Suivi OMS TrendHome — v3
   Capture visites, parcours du formulaire COD, paniers abandonnés et attribution publicitaire.
   Envoi en text/plain : évite la requête de contrôle CORS, que sendBeacon ne peut pas satisfaire.
   Diagnostic : window.OMS_DEBUG = true dans la console pour voir les envois.

   v3 : joint l'appareil, la session et l'attribution à la commande COD elle-même
   (voir « Rattachement à la commande » en bas de fichier).
*/
(function () {
  'use strict';

  var TRK = 'https://trendhome-oms-connector.netlify.app/track';

  function log() {
    if (window.OMS_DEBUG && window.console) console.log.apply(console, ['[OMS]'].concat([].slice.call(arguments)));
  }

  /* --- Identifiants --- */
  function persistant(cle, prefixe, store) {
    try {
      var v = store.getItem(cle);
      if (!v) {
        v = prefixe + '_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
        store.setItem(cle, v);
      }
      return v;
    } catch (e) { return prefixe + '_anon'; }
  }
  var DEVICE_ID = persistant('oms_did', 'd', window.localStorage);
  var SESSION_ID = persistant('oms_sid', 's', window.sessionStorage);

  /* --- Attribution publicitaire, conservée pour la session --- */
  try {
    var P = new URLSearchParams(location.search);
    ['utm_source', 'utm_campaign', 'utm_content', 'fbclid'].forEach(function (k) {
      if (P.get(k)) sessionStorage.setItem('oms_' + k, P.get(k));
    });
  } catch (e) {}
  function attr(k) { try { return sessionStorage.getItem('oms_' + k) || null; } catch (e) { return null; } }

  /* Identifiants et attribution, exposés pour le formulaire COD */
  function identifiants() {
    return {
      device_id: DEVICE_ID,
      session_id: SESSION_ID,
      utm_source: attr('utm_source'),
      utm_campaign: attr('utm_campaign'),
      utm_content: attr('utm_content'),
      fbclid: attr('fbclid')
    };
  }
  window.omsIds = identifiants;

  /* --- Envoi non bloquant --- */
  function track(kind, extra) {
    try {
      var corps = {
        session_id: SESSION_ID, device_id: DEVICE_ID, kind: kind,
        utm_source: attr('utm_source'), utm_campaign: attr('utm_campaign'),
        utm_content: attr('utm_content'), fbclid: attr('fbclid')
      };
      for (var k in (extra || {})) corps[k] = extra[k];
      var data = JSON.stringify(corps);
      log(kind, corps);
      var envoye = false;
      if (navigator.sendBeacon) {
        // text/plain : type sûr pour CORS, le serveur lit le corps en JSON
        envoye = navigator.sendBeacon(TRK, new Blob([data], { type: 'text/plain;charset=UTF-8' }));
      }
      if (!envoye) {
        fetch(TRK, { method: 'POST', body: data, headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, keepalive: true, mode: 'cors' })
          .then(function (r) { log('fetch', r.status); })
          .catch(function (e) { log('échec', e); });
      }
    } catch (e) { log('erreur', e); }
  }
  window.omsTrack = track;

  /* --- Lecture de l'état du formulaire --- */
  function val(id) { var e = document.getElementById(id); return e ? e.value.trim() : ''; }
  function btnTexte(id) {
    var e = document.getElementById(id);
    if (!e || e.hasAttribute('data-empty')) return '';
    var t = (e.textContent || '').trim();
    return (t.indexOf('*') !== -1) ? '' : t;
  }
  function montant() {
    try {
      var t = document.querySelector('#cod-totals .cod-total span:last-child');
      if (!t) return null;
      var n = parseInt((t.textContent || '').replace(/[^0-9]/g, ''), 10);
      return isNaN(n) ? null : n;
    } catch (e) { return null; }
  }
  function produit() {
    try {
      var l = document.querySelector('#cod-summary .cod-line-title');
      if (l) return (l.textContent || '').trim();
      var p = document.getElementById('cod-product-data');
      if (p) return (JSON.parse(p.textContent) || {}).title || null;
    } catch (e) {}
    return null;
  }
  function etatFormulaire(etape) {
    return {
      phone: val('cod-phone'), name: val('cod-name'),
      wilaya: btnTexte('cod-wilaya-btn'), commune: btnTexte('cod-commune-btn'),
      product_title: produit(), amount: montant(), step: etape || 'form'
    };
  }

  var formulaireOuvert = false, soumis = false, dernierEnvoi = 0;

  function majPanier(etape) {
    var e = etatFormulaire(etape);
    if (!e.phone && !e.name && !e.wilaya) return;
    var now = Date.now();
    if (now - dernierEnvoi < 1200) return;
    dernierEnvoi = now;
    track('form_field', e);
  }

  /* --- Vue de page --- */
  track('page', { product_title: produit() });

  /* --- Ouverture du formulaire --- */
  function surveillerModal() {
    var modal = document.getElementById('cod-modal');
    if (!modal) { log('pas de #cod-modal sur cette page'); return; }
    try {
      new MutationObserver(function () {
        var ouvert = !modal.hidden;
        if (ouvert && !formulaireOuvert) {
          formulaireOuvert = true; soumis = false;
          track('form_open', { product_title: produit(), amount: montant() });
        } else if (!ouvert && formulaireOuvert) {
          formulaireOuvert = false;
          if (!soumis) majPanier('fermeture');
        }
      }).observe(modal, { attributes: true, attributeFilter: ['hidden'] });
    } catch (e) { log('observer KO', e); }
  }

  /* --- Saisie des champs --- */
  function surveillerChamps() {
    ['cod-name', 'cod-phone', 'cod-phone2'].forEach(function (id) {
      var e = document.getElementById(id);
      if (!e) return;
      e.addEventListener('blur', function () { majPanier(id.replace('cod-', '')); });
      e.addEventListener('change', function () { majPanier(id.replace('cod-', '')); });
    });
    var picker = document.getElementById('cod-picker');
    if (picker) {
      picker.addEventListener('click', function (ev) {
        if (ev.target.closest && ev.target.closest('.cod-picker-item')) {
          setTimeout(function () { majPanier('localite'); }, 300);
        }
      });
    }
    var submit = document.getElementById('cod-submit');
    if (submit) {
      submit.addEventListener('click', function () {
        soumis = true;
        track('submit', etatFormulaire('submit'));
      }, true);
    }
  }

  /* --- Abandon --- */
  function surveillerDepart() {
    var partir = function () {
      if (soumis) return;
      var e = etatFormulaire('abandon');
      if (!e.phone) return;
      track('form_abandon', e);
    };
    window.addEventListener('pagehide', partir);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') partir();
    });
  }

  /* --- Rattachement à la commande ---------------------------------------
     Le formulaire COD envoie sa commande à son propre endpoint. Pour que
     l'OMS relie la commande à l'appareil sans dépendre d'un recoupement de
     téléphone à 3 h près, on ajoute l'appareil, la session et l'attribution
     au corps de cette requête.

     L'enrichissement se fait ici, et non dans cod-form.js, pour que toute la
     logique de suivi reste dans un seul fichier : le formulaire de commande
     n'est pas modifié, donc aucun risque pour la prise de commande.
     Tout est enveloppé : en cas de problème, la requête d'origine part
     inchangée.
  --------------------------------------------------------------------- */
  function surveillerEnvoiCommande() {
    var modal = document.getElementById('cod-modal');
    var endpoint = modal && modal.dataset ? (modal.dataset.endpoint || '') : '';
    if (!endpoint) { log('pas d endpoint COD : enrichissement inactif'); return; }

    var fetchOrigine = window.fetch;
    if (typeof fetchOrigine !== 'function') return;

    window.fetch = function (entree, options) {
      try {
        var url = (typeof entree === 'string') ? entree : (entree && entree.url) || '';
        var estCommande = url && endpoint && url.indexOf(endpoint) !== -1;
        if (estCommande && options && typeof options.body === 'string') {
          var corps = JSON.parse(options.body);
          var ids = identifiants();
          for (var k in ids) { if (corps[k] == null) corps[k] = ids[k]; }
          // Second numéro en champ dédié, en plus de la note déjà envoyée
          var p2 = val('cod-phone2').replace(/\s+/g, '');
          if (p2 && corps.telephone_2 == null) corps.telephone_2 = p2;
          options = Object.assign({}, options, { body: JSON.stringify(corps) });
          log('commande enrichie', ids, p2 ? { telephone_2: p2 } : {});
        }
      } catch (e) { log('enrichissement ignoré', e); }
      return fetchOrigine.apply(this, [entree, options]);
    };
  }

  function init() {
    surveillerModal();
    surveillerChamps();
    surveillerDepart();
    surveillerEnvoiCommande();
    log('suivi actif', { session: SESSION_ID, device: DEVICE_ID });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
